import {
    CalendarService
  } from "@/common/api.service"
  import {
    FETCH_CALENDARS,
    FETCH_CALENDAR_EVENTS,
    FETCH_ALL_CALENDAR_EVENTS,
    JOIN_CALENDAR_EVENT,
    UNSUBSCRIBE_CALENDAR_EVENT,
    ADD_ATTENDEE_LIMIT,
    FETCH_PAST_EVENTS,
    SAVE_UPDATE_ATTENDEEE_EVENT,
    RESET_STATE
  } from "./actions.type"
  import {
    SET_CALENDARS,
    SET_CALENDAR_EVENTS,
    SET_CALENDAR_PAST_EVENTS,
    SET_ERROR,
    STATE_RESET,
  } from "./mutations.type"
  const initialState = () => {
    return {
      calendars: [],
      calendarevents: [],
      calendarpastevents: [],
    }
  };
  
  let state = initialState()

  const getters = {
    calendars(state) {
      return state.calendars
    },  
    calendarevents(state) {
      return state.calendarevents
    },  
    calendarpastevents(state) {
      return state.calendarpastevents
    },  
  }

  const actions = {
    async [FETCH_CALENDARS](context, slug) {
      const {
        data
      } = await CalendarService.get(slug);
      context.commit(SET_CALENDARS, data.data);
      return data;
    },
    async [FETCH_ALL_CALENDAR_EVENTS](context, slug) {
      const {
        data
      } = await CalendarService.getEvents(slug);
      context.commit(SET_CALENDAR_EVENTS, data.data);
      return data;
    },
    async [FETCH_CALENDAR_EVENTS](context, slug) {
      const {
        data
      } = await CalendarService.getEvents(slug);
      context.commit(SET_CALENDAR_EVENTS, data.data);
      return data;
    },
    async [FETCH_PAST_EVENTS](context, slug) {
      const {
        data
      } = await CalendarService.getPastEvents(slug);
      context.commit(SET_CALENDAR_PAST_EVENTS, data.data);
      return data;
    },
    async [JOIN_CALENDAR_EVENT]  (context,data){
      return CalendarService.join(data)
      .then(({ data }) => {
        return data
      })
      .catch(error => {
        context.commit(SET_ERROR, error.response.data.errors)
      });
    },
    async [UNSUBSCRIBE_CALENDAR_EVENT]  (context,data){
      return CalendarService.unsubscribe(data)
      .then(({ data }) => {
        return data
      })
      .catch(error => {
        context.commit(SET_ERROR, error.response.data.errors)
      });
    },
    async [ADD_ATTENDEE_LIMIT]  (context,data){
      return CalendarService.set(data)
      .then(({ data }) => {
        return data
      })
      .catch(error => {
        context.commit(SET_ERROR, error.response.data.errors)
      });
    },
    async [SAVE_UPDATE_ATTENDEEE_EVENT]  (context,data){
      return CalendarService.updateAttendeeParticipation(data)
      .then(({ data }) => {
        return data
      })
      .catch(error => {
        context.commit(SET_ERROR, error.response.data.errors)
      });
    },
    [RESET_STATE]({
        commit
      }) {
        commit(STATE_RESET);
      }    
 }

 const mutations = {
    [SET_CALENDARS](state, calendardata) {
        state.calendars = calendardata
    },
    [SET_CALENDAR_EVENTS](state, calendardata) {
        state.calendarevents = calendardata
    },
    [SET_CALENDAR_PAST_EVENTS](state, calendardata) {
        state.calendarpastevents = calendardata
    },
    [SET_ERROR](state, error) {
      state.calendarerrors = error;
    },    
    [STATE_RESET](state) {
      Object.assign(state, initialState())
    }
  };

  export default {
    state,
    getters,
    actions,
    mutations
  };
  